
import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
class AppButton extends React.Component {

   constructor(props) {
     super(props);
     this.getClassName = this.getClassName.bind(this);
   }

   componentDidMount() {

   }

   getClassName() {
    let customClass = '';

    switch(this.props.color) {
       case 'blu':
        customClass = 'btn btn-primary';
        break;
       case 'outlined-blu':
        customClass = 'btn btn-default';
        break;
       case 'red':
        customClass = 'btn btn-danger';
        break;
       case 'outlined-red':
        customClass = 'btn btn-danger btn-danger-alt';
        break;
       case 'green':
        customClass = 'btn btn-success';
        break;
       case 'outlined-green':
        customClass = 'btn btn-success btn-success-alt';
        break;
       case 'none':
        customClass = '';
        break;
       default:
        customClass = 'btn btn-primary';
        break;
    }
    if(this.props.customClass) {
        customClass = customClass + " " + this.props.customClass;
    }
    return customClass;
   }
 
   render() {
    if(this.props.isLinkStyle) {
      return (
       <a id={this.props.id} type={this.props.type ? this.props.type : 'button'} className={this.getClassName()} disabled={this.props.disabled} onClick={this.props.onClick} {...this.props.extraProps}>
         {this.props.iconLeft && (<i className={this.props.iconLeft + " mr-2"}></i>)} {i18next.t(this.props.titleKey)}{this.props.iconCenter && (<i className={this.props.iconCenter}></i>)} {this.props.iconRight && (<i className={this.props.iconRight + " ml-2"}></i>)} {this.props.spanSrOnly && (<span className='sr-only'>{i18next.t(this.props.spanSrOnly)}</span>)}
       </a>
      )
    } else {
      return (
       <button id={this.props.id} type={this.props.type ? this.props.type : 'button'} className={this.getClassName()} disabled={this.props.disabled} onClick={this.props.onClick} {...this.props.extraProps}>
         {this.props.iconLeft && (<i className={this.props.iconLeft + " mr-2"}></i>)} {i18next.t(this.props.titleKey)}{this.props.iconCenter && (<i className={this.props.iconCenter}></i>)} {this.props.iconRight && (<i className={this.props.iconRight + " ml-2"}></i>)} {this.props.spanSrOnly && (<span className='sr-only'>{i18next.t(this.props.spanSrOnly)}</span>)}
       </button>
      )
    }
   }
}
AppButton.propTypes = {
   id: PropTypes.string,
   type: PropTypes.oneOf(['submit', 'button','reset']),
   titleKey: PropTypes.string.isRequired,
   color: PropTypes.oneOf(['blu','outlined-blu', 'red','outlined-red','green','outlined-green', 'none']),
   iconLeft: PropTypes.string,
   iconRight: PropTypes.string,
   iconCenter: PropTypes.string,
   spanSrOnly: PropTypes.string,
   onClick: PropTypes.func,
   disabled: PropTypes.bool,
   customClass: PropTypes.string,
   extraProps: PropTypes.any,
   isLinkStyle: PropTypes.bool
 }

export { AppButton }